const busquedaEncontrada = {
  'Prueba con otras palabras o asegúrate de que estén bien escritas':
    'Probá con otras palabras o asegurate de que estén bien escritas.',
}

export default busquedaEncontrada
